import { RG_TYPE as o } from "@project-rouge/rg-core";
const t = {
  [o.Core]: { color: "white", strokeColor: "black", strokeWidth: 0.03 },
  [o.Corridor]: { color: "white", strokeColor: "black", strokeWidth: 0.03 },
  [o.Floor]: { color: "white", strokeColor: "black", strokeWidth: 0.03 },
  [o.Wall]: { color: "white", strokeColor: "black", strokeWidth: 0.03 },
  [o.Opening]: { color: "white", strokeColor: "white", strokeWidth: 0.03 },
  [o.Window]: { color: "white", strokeColor: "black", strokeWidth: 0.01, secondaryStrokeColor: "black", secondaryStrokeWidth: 0.03, drawDimMod: 2 },
  [o.Door]: { color: "white", strokeColor: "black", strokeWidth: 0.01 },
  [o.Column]: { color: "blue", strokeColor: "black", strokeWidth: 0.01 },
  [o.Room]: { textOnly: !0 }
};
export {
  t as FloorPlanStyleBlackWhite
};
//# sourceMappingURL=index2.js.map
